import React from 'react';
import Label from "Components/Common/components/Label";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useState } from "react";
import { CSSTransition } from "react-transition-group";
import RulesLogs from "./RulesLog";
import closeIcon from "../../../../src/assests/img/close-icon.svg";
import ServiceWrapper from "Services/ServiceWrapper";
import AuthManager from "Common/AuthManager";
import SkeletonElement from "../Category/Shimmer/SkeletonElement";
import moment from "moment";

const API_URL = process.env.REACT_APP_GMS_BACKEND_API_URL;

const RulesQueue = (props) => {
  const { setShowRulesQueue, rulesQueue, fetchRulesQueue } = props;

  const dateFormatter = (timestamp) => {
    const dateTime = moment.unix(timestamp).utc();
    const formattedDateTime = dateTime.format("DD-MMM-YYYY, hh:mm A [UTC]");
    return formattedDateTime;
  };
  const colorObj = {
    Completed: ["#E3FCEF", "#006644"],
    "In Progress": ["#FFF7DB", "#DD7800"],
    "In Queue": ["#DBE9FF", "#0058DD"],
    Failed: ["#FFEBE6", "#BF2600"],
  };

  const [viewLog, setViewLog] = useState(false);
  const [logDataIndex, setLogDataIndex] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const handleViewLog = (index) => {
    setViewLog(true);
    setLogDataIndex(index);
  };

  const handleRetry = async (index) => {
    setLoading(true);
    const res = await ServiceWrapper.doGet(
      `${API_URL}rule_queue/${index}/retry`,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (res?.data?.done) {
      toast.success("Successfully triggered retry mechanism");
    } else {
      toast.error("Log fetch failed.");
    }

    setLoading(false);
  };

  function handleClipbord(id) {
    navigator.clipboard.writeText(id).then(() => toast.success("UID copied"));
  }

  function copy(id, event) {
    event.stopPropagation();
    handleClipbord(id);
  }

  return (
    <div className="form-header tw-z-50" style={{ width: "66%" }}>
      <div className="connection-container d-flex justify-content-between pe-3 ps-3">
        <span className="mb-0 connection-text align-self-center fs-5 tw-ml-5">
          Rules Queue
          <button
            type="button"
            className="btn btn-light btn-sm"
            style={{
              color: "#091caa",
              background: "none",
              border: "none",
              boxShadow: "none",
            }}
            onClick={() => {
              setLoading(true);
              setTimeout(() => {
                fetchRulesQueue();
                setLoading(false);
              }, 2000);
            }}
          >
            <i className="fa fa-sync-alt" />
          </button>
        </span>
        <div className="d-flex align-items-center">
          <button
            className="mb-1 border-0 shadow-none align-self-center btn fw fw-light me-1"
            onClick={() => {
              setShowRulesQueue();
            }}
          >
            <img src={closeIcon} alt="Close icon" />
          </button>
        </div>
      </div>
      {loading ? (
        <div className="p-3 border-bottom">
          <SkeletonElement type="title" />
        </div>
      ) : (
        <>
          <div
            className="shadow-sm table-responsive tw-ml-10"
            style={{ maxHeight: "75vh", maxWidth: "90%" }}
          >
            <table className="table">
              <thead className="sticky-header-table">
                <tr>
                  <th
                    className="align-middle border-1"
                    scope="col"
                    // width="35%"
                    style={{
                      height: "43",
                      borderColor: "#c9cccf",
                      fontFamily: "Noto Sans",
                      fontWeight: 400,
                    }}
                  >
                    <div>
                      <label
                        style={{
                          color: "#5c5f62",
                        }}
                      >
                        Name
                      </label>
                    </div>
                  </th>
                  <th
                    className="align-middle border-1"
                    scope="col"
                    // width="15%"
                    style={{
                      height: "43",
                      fontFamily: "Noto Sans",
                      borderColor: "#c9cccf",
                      fontWeight: 400,
                    }}
                  >
                    <Label
                      message="Rule Action"
                      fontWeight="400"
                      color="#5c5f62"
                    />
                  </th>
                  <th
                    className="align-middle border-1"
                    scope="col"
                    // width="15%"
                    style={{
                      height: "43",
                      fontFamily: "Noto Sans",
                      borderColor: "#c9cccf",
                      fontWeight: 400,
                    }}
                  >
                    <Label
                      message="Commit Status"
                      fontWeight="400"
                      color="#5c5f62"
                    />
                  </th>

                  <th
                    className="align-middle border-1"
                    scope="col"
                    // width="6%"
                    style={{
                      height: "43",
                      fontFamily: "Noto Sans",
                      borderColor: "#c9cccf",
                      fontWeight: 400,
                    }}
                  >
                    <Label
                      message="Last Updated"
                      fontWeight="400"
                      color="#5c5f62"
                    />
                  </th>
                  <th
                    className="align-middle border-1"
                    scope="col"
                    style={{
                      height: "43",
                      fontFamily: "Noto Sans",
                      borderColor: "#c9cccf",
                      fontWeight: 400,
                    }}
                  >
                    <Label
                      message="Edge Count"
                      fontWeight="400"
                      color="#5c5f62"
                    />
                  </th>
                  <th
                    className="align-middle border-1"
                    scope="col"
                    style={{
                      height: "43",
                      fontFamily: "Noto Sans",
                      borderColor: "#c9cccf",
                      fontWeight: 400,
                    }}
                  >
                    <Label message="Log" fontWeight="400" color="#5c5f62" />
                  </th>
                  <th
                    className="align-middle border-1"
                    scope="col"
                    style={{
                      height: "43",
                      fontFamily: "Noto Sans",
                      borderColor: "#c9cccf",
                      fontWeight: 400,
                    }}
                  ></th>
                </tr>
              </thead>
              <tbody>
                {rulesQueue.map((queueItem, index) => {
                  return (
                    <tr
                      className="border-2"
                      style={{
                        padding: "0.5rem",
                        textAlign: "left|center",
                      }}
                      key={index}
                    >
                      <th style={{ cursor: "pointer" }}>
                        <div className="d-flex align-items-center">
                          <div
                            className=""
                            style={{
                              height: "43",
                              fontFamily: "Noto Sans",
                              fontWeight: 400,
                            }}
                            onClick={() => {}}
                          >
                            <Label
                              message={queueItem.rule_name}
                              fontSize={"0.875"}
                              fontWeight="400"
                              showPointer={true}
                              fontFamily="Noto Sans"
                              onClick={() => {}}
                            />
                            <br />

                            <div className="d-flex w-75">
                              <Label
                                message={queueItem.uid}
                                fontSize={"0.7"}
                                showPointer={true}
                                fontWeight="300"
                                fontFamily="Noto Sans"
                                onClick={() => {}}
                              />
                              &nbsp;&nbsp;
                              {queueItem.showCopyIcon && (
                                <i
                                  className={`${"far"} fa-clipboard tw-text-base tw-cursor-pointer tw-text-["#091caa"]`}
                                  onClick={(event) => {
                                    copy(queueItem.id, event);
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </th>
                      <td
                        className="align-middle "
                        style={{ cursor: "pointer" }}
                        onClick={() => {}}
                      >
                        <div className="cursor-pointer"></div>
                        <Label
                          message={queueItem.action}
                          fontSize={"0.875"}
                          fontWeight="400"
                          fontFamily="Noto Sans"
                        />
                      </td>
                      <td className="align-middle">
                        <button
                          type="button"
                          style={{
                            background: `${colorObj[queueItem.status][0]}`,
                            color: `${colorObj[queueItem.status][1]}`,
                            width: "90%",
                            height: "100%",
                            padding: "2px 12px",
                            borderColor: "transparent",
                            borderRadius: "20px",
                            fontFamily: "Noto Sans",
                            fontWeight: 400,
                            fontSize: "0.7rem",
                          }}
                        >
                          {queueItem.status}
                        </button>
                      </td>
                      <td
                        className="align-middle "
                        style={{ cursor: "pointer" }}
                        onClick={() => {}}
                      >
                        <div className="cursor-pointer"></div>
                        <Label
                          message={dateFormatter(queueItem.created_at)}
                          fontSize={"0.875"}
                          fontWeight="400"
                          fontFamily="Noto Sans"
                        />
                      </td>
                      <td
                        className="align-middle "
                        style={{ cursor: "pointer" }}
                        onClick={() => {}}
                      >
                        <div className="cursor-pointer"></div>
                        <Label
                          message={
                            queueItem?.edge_count ? queueItem.edge_count : ""
                          }
                          fontSize={"0.875"}
                          fontWeight="400"
                          fontFamily="Noto Sans"
                        />
                      </td>
                      <td
                        className="align-middle "
                        style={{ cursor: "pointer", color: "blue" }}
                        onClick={() => {}}
                      >
                        <Link to={"#"} onClick={() => handleViewLog(index)}>
                          View Log
                        </Link>
                      </td>
                      <td
                        className="align-middle "
                        style={{ cursor: "pointer", color: "blue" }}
                      >
                        {queueItem.status == "Failed" && (
                          <Link
                            to={"#"}
                            onClick={() => {
                              handleRetry(rulesQueue[index]?.uid);
                            }}
                          >
                            Retry
                          </Link>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {viewLog && rulesQueue[logDataIndex] && (
            <CSSTransition
              timeout={1000}
              classNames={{
                enterActive: "animate__animated animate__flipInX",
                exitActive: "animate__animated animate__flipOutX",
              }}
            >
              <RulesLogs
                logData={rulesQueue[logDataIndex].logs}
                logId={rulesQueue[logDataIndex].uid}
                setViewLog={setViewLog}
              />
            </CSSTransition>
          )}
        </>
      )}
    </div>
  );
};

export default RulesQueue;
